var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeartFilled = function SvgHeartFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 3.836C10.147 1.93 7.612 1.605 5.458 2.42A6.925 6.925 0 0 0 1 8.944c0 3.944 2.508 7.208 4.957 9.41a22.677 22.677 0 0 0 3.55 2.613c.518.305.987.548 1.372.718.35.155.733.315 1.121.315s.772-.16 1.121-.315c.385-.17.854-.413 1.371-.718a22.668 22.668 0 0 0 3.552-2.614C20.492 16.153 23 12.888 23 8.944a6.921 6.921 0 0 0-4.46-6.52c-2.154-.813-4.688-.49-6.54 1.412Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeartFilled);
export default ForwardRef;